var map = {
	"./desktop/image-xx99-mark-two-headphones.jpg": 1002,
	"./mobile/image-xx99-mark-two-headphones.jpg": 7209,
	"./tablet/image-xx99-mark-two-headphones.jpg": 5413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;